import { QueryOptions } from "../components/Common/useQuery";
import useUserQuery from "../components/Common/useUserQuery";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";

export interface SiteConnectionsDto {
  siteId: string;
  siteName: string;
  products: SharedProductItemDto[];
  sourceConnections: SourceConnectionDto[];
}

export interface SourceConnectionDto {
  connectionId: string;
  sourceSiteName: string;
  sourceBusinessName: string;
  products: SharedProductItemDto[];
  mappings: ProductMappingDto[];
}

export interface SharedProductItemDto {
  id: string;
  name: string;
}

export interface ProductMappingDto {
  productId: string;
  sourceProductIds: string[];
}

const useGetSharedProductConnections = (options?: QueryOptions<SiteConnectionsDto[]>) => {
  const business = useSelectedBusiness();
  return useUserQuery<SiteConnectionsDto[]>(
    { path: `/api/businesses/${business.id}/dataSharing/connections/productMappings` },
    options
  );
};

export default useGetSharedProductConnections;